import { createContext, ReactNode } from 'react';
import { StateSetter } from 'types/utils/React';
import { emptyFunction } from 'utils/functions';
import { DayContentMode } from 'types/Organizer';
import { Event } from 'types/Event';

export type OrganizerContextProps = {
  dayContentMode?: DayContentMode;
  eventToDelete?: Event;
  eventToEdit?: Event;
  setDayContentMode: StateSetter<DayContentMode | undefined>;
  setEventToDelete: StateSetter<Event | undefined>;
  setEventToEdit: StateSetter<Event | undefined>;
};

const initialState = {
  dayContentMode: undefined,
  eventToDelete: undefined,
  eventToEdit: undefined,
  setDayContentMode: emptyFunction,
  setEventToDelete: emptyFunction,
  setEventToEdit: emptyFunction,
};

const organizerContext = createContext<OrganizerContextProps>(initialState),
  { Provider } = organizerContext;

type OrganizerContextProviderProps = OrganizerContextProps & {
  children: ReactNode;
};

const OrganizerContextProvider = ({
  children,
  ...props
}: OrganizerContextProviderProps): JSX.Element => (
  <Provider value={props}>{children}</Provider>
);

export { organizerContext, OrganizerContextProvider };
